import { z } from 'zod';

import { guestClient } from '../clients.js';

const UnsubscribeQuerySchema = z.object({
  token: z.string(),
});

export const unsubscribe = guestClient.mutation({
  url: 'datintell/v1/external_integrations/unsubscribe/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
  querySchema: UnsubscribeQuerySchema,
  processResponse(data) {
    return data;
  },
});
